<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>学习计划</span><span>/</span><span>计划管理</span></div>
    <div class="disFlex between plan-search">
      <div>
        <el-button type="primary" @click="toAdd()">新建计划</el-button>
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-input v-model="formInline.keyword" clearable placeholder="请输入计划名称查询" suffix-icon="el-icon-search">
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-cascader ref="orgCascader" clearable @clear="changeOrgid" :props="props" :visible-change="orgVisible"
              :show-all-levels="false" v-model="orgId" @change="changeOrgid" :placeholder="'选择培训部门'"
              style="width: 100%;">
            </el-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline.state" placeholder="全部状态" clearable>
              <el-option label="未提交" value="0"></el-option>
              <el-option label="已提交" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading">
      <div class="disFlex" style="flex-wrap:wrap;" v-if="tableData.rows.length>0">
        <div class="planInfoBlock" v-for="(item,k) in tableData.rows"
          :style="k>0&&k%2==1&&!collapse?'margin-right:0;':''">
          <div class="disFlex between planevery-header">
            <div :class="'planevery-header-left'+(item.state=='1'?' active':'')">
              {{item.planname}}
            </div>
            <div class="disFlex" style=" align-items: center;height: 52px;cursor: pointer;">
              <div @click="toEdit(item.id)" v-if="item.state=='0'"><img src="@/assets/images/icons/edit.png" />编辑</div>
              <div class="fenge" v-if="item.state=='0'">|</div>
              <div>
                <el-popover placement="right" trigger="hover">
                  <div>
                    <div class="czitem-list" @click="toDatail(item.id)">查看详情
                    </div>
                    <div class="czitem-list" @click="showGlsj(item.id,item.ontype,item.isset)">
                      {{item.isset==0?'设置试卷':'查看试卷'}}
                    </div>
                    <div class="czitem-list" @click="showPxpg(item.id,item.ontype)">
                      评估项目
                    </div>
                    <div class="czitem-list" @click="toPgbg(item.id,item.ontype)">
                      评估报告
                    </div>
                  </div>
                  <span slot="reference">
                    <img src="@/assets/images/icons/shezhi.png" style="margin-top: -2px;" />设置</span>
                </el-popover>

              </div>
            </div>
          </div>
          <div style="margin-top: 13px;">
            <div class="disFlex plan-flex" v-if="item.itype=='2'">
              <span class="likelabel">培训部门：</span>
              <span class="likename" style="padding: 0 3px;">{{item.orgName}}</span>
              <el-tag type="success">线下培训</el-tag>
            </div>
            <div class="disFlex plan-flex">
              <span class="likelabel" v-if="item.itype=='1'">培训部门：</span>
              <span class="likename" style="padding: 0 3px;" v-if="item.itype=='1'">{{item.orgName}}</span>

              <span class="likelabel">学习时长：</span>
              <span class="likename" style="padding-right: 3px;">{{item.littletime}}课时</span>
            </div>
            <div class="disFlex plan-flex between" v-if="item.itype=='1'">
              <div>
                <span class="likelabel">参与人员：</span>
                <span class="likename"
                  style="padding-right: 3px;">{{item.ktUserPlanlist?item.ktUserPlanlist.length:0}}人</span>
              </div>
              <div>
                <i v-if="!item.ktUserPlanlist||item.ktUserPlanlist.length==0" class="el-icon-circle-plus-outline"
                  style="font-size: 20px;color: #0071BA;cursor: pointer;"
                  @click="showXy(item.id,item.ktUserPlanlist)"></i>
                <div v-else class="tx-imgs disFlex">
                  <div v-if="item.ktUserPlanlist&&item.ktUserPlanlist.length>6" class="likeImg" style="z-index: 10000;">
                    <i class="el-icon-more"></i></div>
                  <el-tooltip class="item" effect="light" v-for="(user,u) in item.ktUserPlanlist"
                    :content="user.realName" placement="top-start" :key="u">
                    <img :src="getTxurl(user)"
                      :style="item.ktUserPlanlist&&item.ktUserPlanlist.length<=6&&u==0?'':'margin-left: -10px;z-index:'+(120-u)+''" />
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="disFlex plan-flex">
              <span class="likelabel">学习时间：</span>
              <span class="likename" style="padding-right: 3px;">{{item.startime}} 至 {{item.endtime}}</span>
            </div>
            <div class="disFlex plan-flex">
              <span class="likelabel">创建时间：</span>
              <span class="likename" style="padding-right: 3px;">{{item.createTime}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>
    </div>

    <el-pagination :hide-on-single-page="true" style="margin-top: 10px;text-align: right;" background
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
      :page-sizes="[10, 20, 50, 100]" :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.total">
    </el-pagination>

    <el-dialog title="添加学员" :visible.sync="dialogVisible" width="989px" :append-to-body="true" :destroy-on-close="true">
      <baoming-list :selectUserIds="selectUserIds" @changeBb="changeBb" :wjSrc="wjSrc" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var $this = this;
      return {
        formInline: {
          keyword: '',
          state: '',
          page: 1,
          rows: 10,
          cid: ''
        },
        orgVisible: '',
        orgId: '',
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value,
              children
            } = node;
            var loadUrl = '/system/organization/myTree.htm?type=SYS_ORGTYPE_02'
            if (value && children.length == 0) {
              loadUrl += '&id=' + value;
            }
            if (children && children.length > 0) {
              resolve(children);
            } else {
              $this.$axios.get(loadUrl).then(res => {
                var data = res.data;
                if (data.length > 0) {
                  resolve($this.getNodes(data));
                } else {
                  resolve([]);
                }
              })
            };
          },
        },
        tableData: {
          rows: [],
          total: 0
        },
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        loading: true,
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        txadminUrl: require('@/assets/images/notxsex.png'),
        dialogVisible: false,
        selectUserIds: []
      }
    },
    methods: {
      changeBb: function(selectIdArr, selectRows) {
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
      },
      handleAave: function() {
        var userPlan = [];
        this.selectRows.map((item, i) => {
          userPlan.push({
            username: item.realName,
            userid: item.id,
            avatarurl: item.avatarurl
          })
        });
        var $this = this;
        var url = '/kt/ktUserPlan/add.htm';
        this.$axios.post(url, this.$qs.stringify({
          id: this.planId,
          userPlan: JSON.stringify(userPlan)
        })).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$message({
              message: '添加学员成功！',
              type: 'success',
              onClose: function() {
                $this.getplanList();
                this.dialogVisible = false
              }
            });
          } else {
            this.$message.error(data.message);
          }
        })
      },
      getNodes: function(arr) {
        const nodes = arr.map(item => ({
          value: item.id,
          label: item.text,
          leaf: !item.isParent,
          children: item.children.length > 0 ? this.getNodes(item.children) : []
        }));
        return nodes;
      },
      showGlsj: function(id, ontype, isset) {
        if (isset == '1') {
          this.$router.push('/Company/Addexam?id=' + id);
        } else {
          this.$router.push('/Company/Addexam?currid=' + id + '&ontype=' + ontype);
        }
      },
      getplanList: function() {
        this.loading = true;
        this.$axios.get('/kt/ktProductLeanplan/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false
        })
      },
      showXy: function(id, ktUserPlanlist) {
        var ktUserPlanlist = ktUserPlanlist ? ktUserPlanlist : []
        this.planId = id;
        var selectUserIds = [];
        ktUserPlanlist.map((item) => {
          selectUserIds.push(item.userid);
        });
        this.selectUserIds = selectUserIds;
        this.dialogVisible = true;
      },
      toAdd: function() {
        this.$router.push('/Company/PlanInfo');
      },
      toEdit: function(id) {
        this.$router.push('/Company/PlanInfo?id=' + id);
      },
      toDatail: function(id) {
        this.$router.push('/Company/DeviceInfo?id=' + id);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else if (item.roleCode == "COM_ADMIN_AQKT") {
          return this.txadminUrl
        } else {
          return this.txnoUrl
        }
      },
      // 设置评估项目
      showPxpg(id, ontype) {
        this.$router.push('/Company/Pxpg?id=' + id);
      },
      // 改变培训部门
      changeOrgid(a, b, c) {
        var nodes = this.$refs.orgCascader.getCheckedNodes(1)[0]; //培训部门
        if (nodes) {
          this.$set(this.formInline, 'orgId', this.orgId[this.orgId.length - 1]);
        };
      },
      // 评估报告查看
      toPgbg(id, ontype) {
        this.$router.push('/Company/Pxbaogao?id=' + id);
      }
    },
    created: function() {
      this.$set(this.formInline, 'cid', this.currentUser.cid);
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getplanList()
        },
        deep: true //true 深度监听
      }
    },
    components: {
      BaomingList
    },
  }
</script>

<style>
  .plan-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .plan-search .el-form-item {
    margin-bottom: 0;
  }

  .planInfoBlock {
    width: 525px;
    height: 202px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.04);
    opacity: 1;
    margin: 0 20px 20px 0;
  }

  .planInfoBlock .planevery-header {
    height: 52px;
    opacity: 1;
    background: #e4f3fc;
    border-radius: 4px 4px 0px 0px;
    align-items: center;
    padding: 0 14px;
    color: #9a9a9a;
  }

  .planevery-header-left {
    padding-left: 57px;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #333333;
    height: 52px;
    line-height: 52px;
    position: relative;
  }

  .planevery-header-left::before {
    content: url(../../assets/images/planc.png);
    width: 35px;
    height: 33px;
    position: absolute;
    top: -5px;
    left: 0;
  }

  .planevery-header-left.active::before {
    content: url(../../assets/images/plana.png);
    width: 35px;
    height: 33px;
    position: absolute;
    top: -5px;
    left: 0;
  }

  .fenge {
    padding: 0 19px;
  }

  .planInfoBlock .planevery-header img {
    padding-right: 6px;
  }

  .plan-flex {
    margin-top: 10px;
    font-size: 14px;
    padding: 0 14px;
    align-items: center;
    line-height: 22px;
  }

  .likelabel {
    width: 70px;
    text-align: left;
  }

  .likename {
    color: rgba(0, 0, 0, 0.65);
  }

  .el-popover {
    padding: 0;
    width: 110px !important;
    min-width: auto;
  }

  .czitem-list {
    width: 110px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #efefef;
  }

  .tx-imgs {
    width: 90px;
    position: relative;
    height: 20px;
    overflow: hidden;
  }

  .tx-imgs .likeImg {
    width: 20px;
    height: 20px;
    background: #F2F2F2;
    color: #000000;
    /* position: absolute; */
    border-radius: 50%;
  }

  .tx-imgs img {
    width: 20px;
    height: 20px;
    /* position: absolute; */
    border-radius: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/components/company/Plan.vue